import React from "react";
import Home from "../../../images/v2/Home-icon.svg";
import Client from "../../../images/v2/Client-icon.svg";
import Inventory from "../../../images/v2/Inventory.svg";
import Wantlisting from "../../../images/v2/Wantlisting.svg";
import Forms from "../../../images/v2/Forms-icon.svg";
import Reports from "../../../images/v2/Reports-icon.svg";
import LanguageSkill from "../../../images/v2/Language-Skill.svg";
import Help from "../../../images/v2/Help-icon.svg";
import OwnaZip from "../../../images/v2/Own-a-zip.svg";
import { NavLink } from "react-router-dom";
import { getUserType } from "../../../helpers/common";
import { USER_TYPE_AGENT } from "../../../constants/common";
function Sidebar() {
  const userType = getUserType();

  return (
    <div className="sidebar-main">
      <NavLink
        to="/"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu">
          <img src={Home} alt="Gitcha Logo" className="sidebar-menu-img" />
        </div>
        <a className="sidebar-menu-list">Feed</a>
      </NavLink>
      {userType === USER_TYPE_AGENT && (
        <NavLink
          to="/agent-dashboard"
          className="d-flex flex-column align-items-center sidebar-wrapper"
        >
          <div className="sidebar-menu ">
            <img src={Client} alt="Gitcha Logo" className="sidebar-menu-img" />
          </div>
          <a className="sidebar-menu-list">Clients</a>
        </NavLink>
      )}
      <NavLink
        to="/my-inventory-listing"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu ">
          <img src={Inventory} alt="Gitcha Logo" className="sidebar-menu-img" />
        </div>
        <a className="sidebar-menu-list">Inventory</a>
      </NavLink>

      <NavLink
        to="/my-want-ad"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu ">
          <img
            src={Wantlisting}
            alt="Gitcha Logo"
            className="sidebar-menu-img"
          />
        </div>
        <span className="sidebar-menu-list">Want Listings</span>
      </NavLink>

      {/* <NavLink
        to="/"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu ">
          <img src={Forms} alt="Gitcha Logo" className="sidebar-menu-img" />
        </div>
        <a className="sidebar-menu-list">Forms</a>
      </NavLink>
      <NavLink
        to="/"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu ">
          <img src={Reports} alt="Gitcha Logo" className="sidebar-menu-img" />
        </div>
        <a className="sidebar-menu-list">Reports</a>
      </NavLink>
      <NavLink
        to="/"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu ">
          <img
            src={LanguageSkill}
            alt="Gitcha Logo"
            className="sidebar-menu-img"
          />
        </div>
        <a className="sidebar-menu-list">Integrations</a>
      </NavLink> */}
      <NavLink
        to="https://gitcha.com/help"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div className="sidebar-menu">
          <img src={Help} alt="Gitcha Logo" className="sidebar-menu-img" />
        </div>
        <a className="sidebar-menu-list">Help/Tutorials</a>
      </NavLink>
      {/* <NavLink
        to="/"
        className="d-flex flex-column align-items-center sidebar-wrapper"
      >
        <div>
          <img src={OwnaZip} alt="Gitcha Logo" className="sidebar-menu-img" />
        </div>
        <a className="sidebar-menu-list own-a-link">Own a ZIP</a>
      </NavLink> */}
    </div>
  );
}

export default Sidebar;
